import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import { EnableAsyncInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentEnableAsync({
	data,
	setData,
}: {
	data: EnableAsyncInterface;
	setData: (newValue: EnableAsyncInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string) => {
		const copy = structuredClone(data);
		copy.group_name = newValue;
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.group_name}
				inputLabelName={t("general.groupName")}
				inputOnChange={onChangeValue}
				inputVariableName='group_name'
				isRequired
				disabledInput={false}
				
			/>
		</div>
	);
}
